export default [
  {
    children: [
      {
        label: "_.my_tickets",
        to: {
          name: "clientSupportTickets"
        },
        children: [
          {
            label: "_.add",
            to: {
              name: "clientSupportAddTicket"
            }
          }
        ]
      }
    ]
  }
];
